import { takeLatest, put, select, call } from 'redux-saga/effects';
import firebase from 'firebase/app';
import 'firebase/firestore';
import axios from 'axios';

import {
	// New fields
	INPUT_CONTACT_SCHOOL_NAME,
	INPUT_CONTACT_CLASS_NAME,
	INPUT_CONTACT_COMMITTEE_PRESIDENT,
	INPUT_CONTACT_COMMITTEE_PHONE,
	INPUT_CONTACT_COMMITTEE_EMAIL,
	INPUT_CONTACT_CLASS_PRESIDENT,
	INPUT_CONTACT_CLASS_PHONE,
	INPUT_CONTACT_CLASS_EMAIL,
	INPUT_CONTACT_DATE_PROM,
	INPUT_CONTACT_GUESTS_NUM,
	// New regular fields
	INPUT_CONTACT_PHONE,
	INPUT_CONTACT_DATE_EVENT,
	INPUT_CONTACT_TYPE_EVENT,
	// Original fields
	INPUT_CONTACT_NAME,
	INPUT_CONTACT_EMAIL,
	INPUT_CONTACT_MSG,
	SEND_CONTACT,
	SET_CONTACT_DB,
	GET_CONTACT_DB,
	SET_CONTACT_STATUS
} from '../actions/Types';

export function* contactSaga() {
	yield takeLatest(SEND_CONTACT, sendContact);
	yield takeLatest(GET_CONTACT_DB, getContact);
}

function* getContact() {
	try {
		const contact = yield call(firebaseGet);
		yield put({ type: SET_CONTACT_DB, payload: contact });
	} catch (error) {
		yield put({ type: SET_CONTACT_DB, payload: '' });
		console.log('getContact res error', error);
	}
}

function* sendContact() {
	yield put({ type: SET_CONTACT_STATUS, payload: 'loading' });

	try {
		const state = yield select(state => state.ContactReducer);
		let msg = `
			<b>Nombre de la escuela:</b> ${state.schoolName} <br />
			<b>Nombre de la clase:</b> ${state.className} <br />
			<b>Presidente del comité de padres:</b> ${state.commPresident} <br />
			<b>Teléfono:</b> ${state.commPhone} <br />
			<b>E-mail:</b> ${state.commEmail} <br />
			<b>Presidente de la clase graduanda:</b> ${state.classPresident} <br />
			<b>Teléfono:</b> ${state.classPhone} <br />
			<b>E-mail:</b> ${state.classEmail} <br />
			<b>Fecha para el prom:</b> ${state.dateProm} <br />
			<b>Cantidad de invitados:</b> ${state.guestsNumber} <br />

			<b>Nombre:</b> ${state.name} <br />
			<b>E-Mail:</b> ${state.email} <br />
			<b>Teléfono:</b> ${state.phone} <br />
			<b>Fecha del evento:</b> ${state.dateEvent} <br />
			<b>Tipo de evento:</b> ${state.typeEvent} <br />

			<b>Mensaje:</b> ${state.msg} <br />
		`;

		let params = {
			to: state.emailDB,
			subject: 'Contacto Montamos tu Patry',
			msg
		};

		yield call(axiosSend, params);
		// New fields
		yield put({ type: INPUT_CONTACT_SCHOOL_NAME, payload: '' });
		yield put({ type: INPUT_CONTACT_CLASS_NAME, payload: '' });
		yield put({ type: INPUT_CONTACT_COMMITTEE_PRESIDENT, payload: '' });
		yield put({ type: INPUT_CONTACT_COMMITTEE_PHONE, payload: '' });
		yield put({ type: INPUT_CONTACT_COMMITTEE_EMAIL, payload: '' });
		yield put({ type: INPUT_CONTACT_CLASS_PRESIDENT, payload: '' });
		yield put({ type: INPUT_CONTACT_CLASS_PHONE, payload: '' });
		yield put({ type: INPUT_CONTACT_CLASS_EMAIL, payload: '' });
		yield put({ type: INPUT_CONTACT_DATE_PROM, payload: '' });
		yield put({ type: INPUT_CONTACT_GUESTS_NUM, payload: '' });
		// New regular fields
		yield put({ type: INPUT_CONTACT_PHONE, payload: '' });
		yield put({ type: INPUT_CONTACT_DATE_EVENT, payload: '' });
		yield put({ type: INPUT_CONTACT_TYPE_EVENT, payload: '' });
		// Original fields
		yield put({ type: INPUT_CONTACT_NAME, payload: '' });
		yield put({ type: INPUT_CONTACT_EMAIL, payload: '' });
		yield put({ type: INPUT_CONTACT_MSG, payload: '' });
		yield put({ type: SET_CONTACT_STATUS, payload: 'ok' });
		// console.log('sendContact', res.data);
	} catch (error) {
		console.log('sendContact error', error);
		yield put({ type: SET_CONTACT_STATUS, payload: 'error' });
	}
};

const axiosSend = params => {
	return axios.post(`https://morfosweb.com/contato_senior.php`, params);
};

const firebaseGet = () => {
	const firestore = firebase.firestore();
	return firestore.collection('database').doc('base').get().then(snap => {
		return snap.data().contact || '';
	});
};


// WEBPACK FOOTER //
// ./src/sagas/contactSaga.js